import PrivacyPolicy from '@/assets/questbet/pdf/privacy_policy.pdf';
import TermsAndConditions from '@/assets/questbet/pdf/terms_and_conditions.pdf';

export default {
  PrivacyPolicy,
  TermsAndConditions,
};
